import { Newspaper, CircleNotch as Loader2 } from "@phosphor-icons/react";
import { useNewsPosts } from "@/hooks/useNewsPosts";
import { NewsPostCard } from "./NewsPostCard";

interface NewsSectionProps {
  blogPrefix: string;
  country: string;
  category?: string;
}

export const NewsSection = ({ blogPrefix, country, category }: NewsSectionProps) => {
  const { data: newsPosts, isLoading, error } = useNewsPosts({
    country,
    status: "all",
    limit: 12,
    category: category || undefined,
  });

  if (isLoading) {
    return (
      <div className="mb-12">
        <div className="flex items-center gap-2 mb-6">
          <Newspaper className="text-primary" size={24} />
          <h2 className="text-2xl md:text-3xl font-semibold font-serif">Știri auto</h2>
        </div>
        <div className="flex items-center justify-center py-12">
          <Loader2 className="animate-spin text-primary" size={32} />
        </div>
      </div>
    );
  }

  if (error || !newsPosts || newsPosts.length === 0) {
    return null; // Don't show section if no news posts
  }

  const featuredPosts = newsPosts.slice(0, 2);
  const regularPosts = newsPosts.slice(2);

  return (
    <div className="mb-12">
      <div className="mb-6">
        <div className="flex items-center gap-2">
          <Newspaper className="text-foreground" size={24} />
          <h2 className="text-2xl md:text-3xl font-semibold font-serif">Știri auto</h2>
        </div>
        <p className="mt-1 text-sm text-muted-foreground">Rezumate automate din surse publice, cu link la sursa originală.</p>
      </div>

      {/* Featured news posts */}
      {featuredPosts.length > 0 && (
        <div className="grid md:grid-cols-2 gap-6 mb-6">
          {featuredPosts.map((post) => (
            <NewsPostCard
              key={post.id}
              post={post}
              blogPrefix={blogPrefix}
              featured
            />
          ))}
        </div>
      )}

      {/* Regular news posts */}
      {regularPosts.length > 0 && (
        <div className="grid md:grid-cols-3 gap-6">
          {regularPosts.map((post) => (
            <NewsPostCard
              key={post.id}
              post={post}
              blogPrefix={blogPrefix}
            />
          ))}
        </div>
      )}
    </div>
  );
};
